import {monolithPost} from './fetch'

export const applyPromoCode = (code) => monolithPost('/ajax/cart/apply-code', {code})
